import { supabase } from '@/lib/supabase'

export interface AppFeedbackInsert {
  user_id: string
  organization_id: string | null
  message: string
  current_path: string | null
  user_agent: string | null
  created_at: string
}

interface AppFeedbackInput {
  userId: string
  organizationId?: string | null
  message: string
  currentPath?: string | null
  userAgent?: string | null
  createdAt?: string
}

interface AppFeedbackClient {
  from: (table: 'app_feedback') => {
    insert: (payload: AppFeedbackInsert) => PromiseLike<{ error: unknown }>
  }
}

function optionalText(value: string | null | undefined): string | null {
  const trimmed = value?.trim()
  return trimmed ? trimmed : null
}

export function buildAppFeedbackInsert(params: AppFeedbackInput): AppFeedbackInsert {
  return {
    user_id: params.userId,
    organization_id: params.organizationId ?? null,
    message: params.message.trim(),
    current_path: optionalText(params.currentPath),
    user_agent: optionalText(params.userAgent),
    created_at: params.createdAt ?? new Date().toISOString(),
  }
}

export async function saveAppFeedback(
  payload: AppFeedbackInsert,
  client: AppFeedbackClient = supabase as unknown as AppFeedbackClient,
): Promise<void> {
  const { error } = await client
    .from('app_feedback')
    .insert(payload)

  if (error) throw error
}
